<style src="./Video.scss" lang="scss" scoped></style>
<template>
  <section class="video-all">
    <!-- DESKTOP -->
    <section class="room">
      <div class="video-screen">
        <div class="box-wait" v-show="!enterProfessional">
          <div class="text">{{ textBackground }}</div>
          <div class="lds-default">
            <div></div><div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div><div></div>
            <div></div><div></div>
          </div>
        </div>
        <div v-show="enterProfessional" class="expand_stream" id="expand_stream"></div>
      </div>

      <div class="video-local">
        <div class="local_stream" id="local_stream"></div>
      </div>

      <div class="acts">
        <div class="btn-circle blue" :class="{'on': isBtnMicroOn}" 
        @click="onClickMicrophone" title="Ativar/Desativar Microfone">
          <IconBtnMicroOff v-if="!isBtnMicroOn"/>
          <IconBtnMicroOn v-else/>
        </div>
        <div class="btn-circle green middle" :class="{'on': isBtnCamOn}" 
        @click="onClickCamera" title="Ativar/Desativar Câmera">
          <IconBtnCamOff v-if="!isBtnCamOn"/>
          <IconBtnCamOn v-else/>
        </div>
        <div class="btn-circle red" @click="onClickShowModalExit" title="Sair da chamada">
          <IconBtnExit/>
        </div>
      </div>
    </section>
    <!-- MODAL DESKTOP SAIDA -->
    <section class="modal" v-if="showModalExit">
      <div class="modal-container">
        <div class="left">
          <div class="title">Deseja sair da sala?</div>
          <div class="sub-title">Realmente deseja finalizar a consulta?</div>
          <div class="modal-acts">
            <div class="btn-modal" @click="actExit">
              <div>Sim</div><i class="fas fa-times"></i>
            </div>
            <div class="btn-modal green" @click="onClickHideModalExit">
              <div>Voltar para a Sala</div><i class="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>
        <div class="right"><IconFigExit /></div>
      </div>
    </section>
    <!-- *** *** *** -->
  </section>
</template>

<script>
import ApiService from './services/ApiService'
import FirebaseService from './services/FirebaseService'
import AgoraService from './services/AgoraService'

import IconBtnCamOff from '@/assets/icons/IconBtnCamOff'
import IconBtnMicroOff from '@/assets/icons/IconBtnMicroOff'
import IconBtnCamOn from '@/assets/icons/IconBtnCamOn'
import IconBtnMicroOn from '@/assets/icons/IconBtnMicroOn'
import IconBtnExit from '@/assets/icons/IconBtnExit'
import IconFigExit from '@/assets/icons/IconFigExit'


export default {
  name: 'PortalVideo',
  props: {
    cpf: String,
    startRoom: Boolean
  },
  components: {
    IconBtnMicroOff,
    IconBtnMicroOn,
    IconBtnCamOff,
    IconBtnCamOn,
    IconBtnExit,
    IconFigExit
  },
  
  // ****************
  data () {
    return {
      rtc: {
        client: null,
        joined: false,
        published: false,
        localStream: null,
        remoteStreams: [],
        params: {}
      },
      listRemoteStreams: [],

      videoOn: true,
      audioOn: true,

      agoraUID: null,
      channelName: null,
      clientRTM: null,
      tokenRTM: null,
      appID: '61cf3781778b4a15a3460bd5ab7814bb', // rg homologacao

      isWaitServiceRoom: false,
      isCamOff: true,
      isDisabledBtn: true,
      isBtnSoundOn: true,
      profissionalEntered: false,
      qsId: null,
      // ! - novo
      FirebaseService: null,
      AgoraService: null,
      agoraToken: null,
      innerWidth: 0,
      isBtnMicroOn: true,
      isBtnCamOn: true,
      showModalExit: false,
      enterProfessional: false,
      titleBtnMicro: `Microfone Ativado`,
      titleBtnCam: `Câmera Ativada`,
      textBackground: 'Esperando um médico para a consulta...'
    }
  },

  watch: {
    startRoom (val) {
      this.prepareRoom()
    }
  },

  beforeDestroy () {
  },

  async beforeMount () {
    this.FirebaseService = new FirebaseService()
    this.ApiService = new ApiService()
  },

  async mounted() {
    this.AgoraService = new AgoraService(
      this.callbackEnterProfessional
    )
  },
  
  
  methods: {
    /**
     * Exibe/Oculta a modal de saída.
     */
    onClickShowModalExit () {
      this.showModalExit = true
    },
    onClickHideModalExit () {
      this.showModalExit = false
    },

    /**
     * Finaliza o vídeo e emite um evento para fechar a sala.
     */
    actExit () {
      this.showModalExit = false
      this.FirebaseService.removeTelehealthRoom(this.cpf)
      setTimeout(() => {
        this.AgoraService.closeVideo((status) => {
          this.$emit('close', true)
        })
      }, 100)
    },

    /**
     * Atualiza o status de entrada do profissional.
     * @param {boolean} status - O novo status indicando se o 
     * profissional entrou ou não.
     */
    callbackEnterProfessional (status) {
      this.enterProfessional = status
      this.textBackground = `O profissional está ausente agora. Se o atendimento não foi concluído, por favor, fique na sala.`
    },

    /**
     * Alterna o estado do microfone e salva o log de ativação ou desativação.
     */
    onClickMicrophone () {
      this.isBtnMicroOn = !this.isBtnMicroOn
      this.AgoraService.audioOnOff((response) => {
        if (response.status) {
          this.audioOn = true
        } else {
          this.audioOn = false
        }
      })
    },

    /**
     * Alterna o estado da câmera e salva o log de ativação ou desativação.
     */
    onClickCamera () {
      this.isBtnCamOn = !this.isBtnCamOn
      this.AgoraService.videoOnOff((response) => {
        if (response.status) {
          this.videoOn = true
        } else {
          this.videoOn = false
        }
      })
    },

    /**
     * Prepara a sala PA (sala de atendimento profissional) encerrando o 
     * vídeo atual e criando uma nova sala.
     * @async
     */
    async prepareRoom () {
      this.AgoraService.closeVideo((responseCloseVideo) => {
        if (responseCloseVideo.status) {
          this.createRoom()
        } else {
          console.error('[CabineVideo] (prepareRoom) Erro ao preparar sala')
        }
      })
    },

    /**
     * Cria uma nova sala de vídeo no Agora e 
     * atualiza os dados da sala no Firebase.
     * @async
     */
    async createRoom () {
      const cpfFormat = this.cpf.replace(/[.-]/g, '')
      this.AgoraService.createRoom(cpfFormat, async (objCreateRoom) => {
        if (objCreateRoom.status) {
          this.agoraToken = objCreateRoom.agoraToken
          const channelName = objCreateRoom.agoraToken.canal
          await this.FirebaseService.setFirebaseRoom(cpfFormat, this.agoraToken)
          const pacStreamId = `pacCpf_${cpfFormat}`
          await this.FirebaseService.updateFirebaseRoom(cpfFormat, 'pacStreamId', pacStreamId)
          this.listenerRoomLinkAgora(channelName)
        } else {
          console.error('[CabineVideo] (createRoom) Erro ao criar sala', objCreateRoom)
        }
      })
    },

    /**
     * Monitora a sala de vídeo no Firebase e exibe o modal de permissão 
     * de entrada, se necessário.
     * @param {string} channelName - O nome do canal a ser monitorado.
     */
    listenerRoomLinkAgora () {
      this.FirebaseService.listenerRoomByCpf(this.cpf, (resListener) => {
        if (!resListener) {
          return
        }
        if (!resListener.agoraSdk) {
          return
        }
        if (resListener.agoraSdk.pergunta === `pergunta`) {
          this.FirebaseService.updateFirebaseRoom(this.cpf, 'pergunta', 'resposta')
        }
      })
    }
    // ! ---------------
    // ! OLD
    // // * ACOES LOCAIS
    // actShowCloseRoom () {
    //   this.showModalExit = true
    // },
    // actCloseRoom () {
    //   this.showModalExit = false
    //   this.actLeaveRoom()
    //   this.isWaitServiceRoom = false
    //   Firebase.removeFirebaseRoom(this.agoraUID)
    //   Firebase.removeCallRoom(this.qsId)
    //   this.$emit('close')
    // },
    // actCloseMicro () {
    //   console.log("actCloseMicro")
    //   this.clickAudioOnOff()
    // },
    // actCloseSound () {
    //   console.log("actCloseSound")
    // },
    // actCloseVideoSelf () {
    //   console.log("actCloseVideoSelf")
    //   this.clickVideoOnOff()
    // },
    // actCloseVideoOther () {
    //   console.log("actCloseVideoOther")
    // },
    // actStartService () {
    //   this.isWaitServiceRoom = false
    //   this.rtc.localStream.stop()
    //   this.rtc.localStream.play('local_stream_big')
    // },
    // // * ACOES DE SALA
    // async actStartRoom() {
    //   let obj = {
    //     canal: this.channelName,
    //     uid: this.agoraUID
    //   }
    //   let tmpToken = await Agora.getToken(obj)
    //   obj.token = tmpToken
      
    //   Agora.join(obj, this.rtc, this.appID, async ret => {
    //     this.isCamOff = false
    //     this.isDisabledBtn = false
    //     Firebase.setFirebaseRoom(this.agoraUID, this.channelName, tmpToken)
    //     if (ret.code !== 'error') {
    //       // *** PRIMEIRO ON
    //       this.rtc.client.on('stream-added', evt => {
    //         let remoteStream = evt.stream
    //         let id = remoteStream.getId()
    //         if (id !== this.rtc.params.uid) {
    //           this.rtc.client.subscribe(remoteStream, err => {
    //             console.error('stream subscribe failed', err)
    //           })
    //         }
    //       })
    //       // *** SEGUNDO ON
    //       this.rtc.client.on('stream-subscribed', evt => {
    //         this.profissionalEntered = true
    //         let remoteStream = evt.stream
    //         remoteStream.setAudioVolume(20)
    //         let id = remoteStream.getId()
    //         this.addView(id)
    //         remoteStream.play('remote_video_' + id)
    //         this.listRemoteStreams.push({
    //           id: id.toString(),
    //           stream: remoteStream,
    //           expand: false
    //         })
    //       })
    //       // *** TERCEIRO ON
    //       this.rtc.client.on('peer-leave', evt => {
    //         var uid = evt.uid
    //         this.removeView(uid)
    //       })

    //       this.$forceUpdate()
    //     } else {
    //       console.error('ERROR AGORA.JOIN', ret.msg)
    //       console.error(ret)
    //     }
    //   })

    //   setTimeout(()=>{
    //     this.actStartService()
    //   }, 5000)
    // },
    // actLeaveRoom() {
    //   Firebase.removeFirebaseRoom(this.agoraUID)
    //   Firebase.removeCallRoom(this.qsId)
    //   if (!this.rtc.client) {
    //     return
    //   }
    //   this.rtc.client.leave(
    //     async () => {
    //       this.rtc.localStream.stop()
    //       this.rtc.localStream.close()
    //       for (let i in this.listRemoteStreams) {
    //         let remote = this.listRemoteStreams[i]
    //         remote.stream.stop()
    //         this.removeView(remote.id)
    //       }
    //       this.rtc.client = null
    //       this.$forceUpdate()
    //     },
    //     err => {
    //       console.error('channel leave failed')
    //       console.error(err)
    //     }
    //   )
    // },
    // // * JQUERY
    // removeView(id) {
    //   let temp = document.getElementById('remote_video_panel_' + id)
    //   if (temp) {
    //     document.getElementById('remote_video_panel_' + id).remove()
    //   }
    //   this.$forceUpdate()
    // },
    // addView(id) {
    //   let temp = document.getElementById(id)
    //   if (!temp) {
    //     let videoView = Agora.createVideoView(id, true)
    //     document.getElementById('expand_stream').appendChild(videoView)
    //     let videoPlaceholder = Agora.createVideoPlaceholder(id)
    //     videoView.appendChild(videoPlaceholder)
    //   }
    // },
    // // * ACOES DO RTC LOCAL
    // clickVideoOnOff() {
    //   this.isBtnCamOn ? this.rtc.localStream.disableVideo() : this.rtc.localStream.enableVideo()
    //   this.isBtnCamOn = !this.isBtnCamOn
    // },
    // clickAudioOnOff() {
    //   this.isBtnMicroOn ? this.rtc.localStream.disableAudio() : this.rtc.localStream.enableAudio()
    //   this.isBtnMicroOn = !this.isBtnMicroOn
    // }
  }
}
</script>
